"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Slot = /** @class */ (function () {
    function Slot() {
    }
    return Slot;
}());
exports.Slot = Slot;
